// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.device-control-page {
  min-height: 124vh;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.device-control-page .animated-bg {
  position: absolute;
  inset: 0;
}
.device-control-page .animated-bg span {
  position: absolute;
  width: 260px;
  height: 260px;
  border-radius: 50%;
  filter: blur(6px);
  opacity: 0.45;
  animation: floatBubble 8s infinite ease-in-out;
}
.device-control-page .animated-bg span:nth-child(1) {
  background: #22d3ee;
  top: 10%;
  left: 10%;
}
.device-control-page .animated-bg span:nth-child(2) {
  background: #a855f7;
  right: 12%;
  top: 20%;
  animation-delay: 2s;
}
.device-control-page .animated-bg span:nth-child(3) {
  background: #14b8a6;
  bottom: 8%;
  left: 35%;
  animation-delay: 4s;
}
.device-control-page .device-card {
  width: 100%;
  max-width: 460px;
  position: relative;
  z-index: 2;
  padding: 34px;
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.16);
  backdrop-filter: blur(18px);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.22);
  animation: cardEnter 0.7s ease;
  background-color: #0f172a;
}
.device-control-page .device-card h1 {
  margin: 14px 0 6px;
  text-align: center;
  color: #ffffff;
  font-size: 32px;
  font-weight: 800;
}
.device-control-page .device-card .subtitle {
  text-align: center;
  color: rgba(255, 255, 255, 0.75);
  margin-bottom: 26px;
}
.device-control-page .device-icon {
  width: 84px;
  height: 84px;
  margin: 0 auto;
  border-radius: 26px;
  background: linear-gradient(135deg, #22d3ee, #8b5cf6);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 16px 35px rgba(34, 211, 238, 0.35);
  animation: pulseIcon 2s infinite;
}
.device-control-page .device-icon span {
  font-size: 42px;
}
.device-control-page .configured-box {
  margin-bottom: 20px;
  padding: 16px;
  border-radius: 18px;
  background: rgba(8, 172, 68, 0.64);
  border: 1px solid rgba(34, 197, 94, 0.92);
  color: #ffffff;
}
.device-control-page .configured-box span {
  display: block;
  font-size: 13px;
  opacity: 0.75;
  margin-bottom: 4px;
  color: #ffffff;
}
.device-control-page .configured-box strong {
  font-size: 20px;
  letter-spacing: 1px;
}
.device-control-page .input-group {
  margin-bottom: 18px;
}
.device-control-page .input-group label {
  display: block;
  margin-bottom: 8px;
  color: #ffffff;
  font-weight: 600;
}
.device-control-page .input-group input {
  width: 100%;
  height: 56px;
  border-radius: 16px;
  border: 2px solid rgba(255, 255, 255, 0.22);
  background: rgba(255, 255, 255, 0.92);
  color: #111827;
  font-size: 18px;
  font-weight: 700;
  padding: 0 16px;
  outline: none;
  transition: 0.25s ease;
}
.device-control-page .input-group input:focus {
  border-color: #22d3ee;
  box-shadow: 0 0 0 5px rgba(34, 211, 238, 0.22);
  transform: translateY(-2px);
}
.device-control-page .example-box {
  margin-bottom: 18px;
}
.device-control-page .example-box p {
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 10px;
  font-size: 14px;
}
.device-control-page .example-box div {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.device-control-page .example-box button {
  border: none;
  border-radius: 999px;
  padding: 8px 14px;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.18);
  cursor: pointer;
  font-weight: 700;
  transition: 0.25s ease;
}
.device-control-page .example-box button:hover {
  background: #22d3ee;
  color: #0f172a;
  transform: translateY(-3px);
}
.device-control-page .alert {
  padding: 13px 15px !important;
  border-radius: 14px;
  margin-bottom: 16px;
  font-weight: 600;
  animation: slideDown 0.3s ease;
}
.device-control-page .alert.error {
  background: rgba(239, 68, 68, 0.57);
  color: #fecaca !important;
  border: 1px solid rgba(239, 68, 68, 0.78);
}
.device-control-page .alert.success {
  background: rgba(34, 197, 94, 0.18);
  color: #bbf7d0 !important;
  border: 1px solid rgba(34, 197, 94, 0.35);
}
.device-control-page .action-row {
  display: flex;
  gap: 12px;
}
.device-control-page .action-row button {
  height: 52px;
  border: none;
  border-radius: 16px;
  font-size: 16px;
  font-weight: 800;
  cursor: pointer;
  transition: 0.25s ease;
}
.device-control-page .save-btn {
  flex: 1 1;
  background: linear-gradient(135deg, #22d3ee, #3b82f6);
  color: #ffffff;
}
.device-control-page .save-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 30px rgba(34, 211, 238, 0.35);
}
.device-control-page .logout-btn {
  flex: 1 1;
  background: rgba(239, 68, 68, 0.85);
  color: #ffffff;
}
.device-control-page .logout-btn:hover {
  background: rgba(239, 68, 68, 0.85);
  transform: translateY(-3px);
}
.device-control-page .clear-btn {
  width: 110px;
  background: rgba(255, 255, 255, 0.18);
  color: #ffffff;
}
.device-control-page .clear-btn:hover {
  background: rgba(239, 68, 68, 0.85);
  transform: translateY(-3px);
}
@keyframes cardEnter {
  from {
    opacity: 0;
    transform: translateY(35px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes floatBubble {
  0%, 100% {
    transform: translateY(0) translateX(0);
  }
  50% {
    transform: translateY(-40px) translateX(35px);
  }
}
@keyframes pulseIcon {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.08);
  }
}
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/pages/manufacturing_app/deviceConfig/DeviceConfigPage.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AACJ;AAGI;EACI,kBAAA;EACA,QAAA;AADR;AAGQ;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,8CAAA;AADZ;AAIQ;EACI,mBAAA;EACA,QAAA;EACA,SAAA;AAFZ;AAKQ;EACI,mBAAA;EACA,UAAA;EACA,QAAA;EACA,mBAAA;AAHZ;AAMQ;EACI,mBAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;AAJZ;AAQI;EACI,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,qCAAA;EACA,2BAAA;EACA,2CAAA;EACA,2CAAA;EACA,8BAAA;EACA,yBAAA;AANR;AAQQ;EACI,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AANZ;AASQ;EACI,kBAAA;EACA,gCAAA;EACA,mBAAA;AAPZ;AAWI;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,qDAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gDAAA;EACA,gCAAA;AATR;AAWQ;EACI,eAAA;AATZ;AAaI;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kCAAA;EACA,yCAAA;EACA,cAAA;AAXR;AAaQ;EACI,cAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;AAXZ;AAcQ;EACI,eAAA;EACA,mBAAA;AAZZ;AAgBI;EACI,mBAAA;AAdR;AAgBQ;EACI,cAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AAdZ;AAiBQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,2CAAA;EACA,qCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;AAfZ;AAiBY;EACI,qBAAA;EACA,8CAAA;EACA,2BAAA;AAfhB;AAoBI;EACI,mBAAA;AAlBR;AAoBQ;EACI,+BAAA;EACA,mBAAA;EACA,eAAA;AAlBZ;AAqBQ;EACI,aAAA;EACA,SAAA;EACA,eAAA;AAnBZ;AAsBQ;EACI,YAAA;EACA,oBAAA;EACA,iBAAA;EACA,cAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AApBZ;AAsBY;EACI,mBAAA;EACA,cAAA;EACA,2BAAA;AApBhB;AAyBI;EACI,6BAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;AAvBR;AAyBQ;EACI,mCAAA;EACA,yBAAA;EACA,yCAAA;AAvBZ;AA0BQ;EACI,mCAAA;EACA,yBAAA;EACA,yCAAA;AAxBZ;AA4BI;EACI,aAAA;EACA,SAAA;AA1BR;AA4BQ;EACI,YAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AA1BZ;AA8BI;EACI,SAAA;EACA,qDAAA;EACA,cAAA;AA5BR;AA8BQ;EACI,2BAAA;EACA,gDAAA;AA5BZ;AAgCI;EACI,SAAA;EACA,mCAAA;EACA,cAAA;AA9BR;AAgCQ;EACI,mCAAA;EACA,2BAAA;AA9BZ;AAkCI;EACI,YAAA;EACA,qCAAA;EACA,cAAA;AAhCR;AAkCQ;EACI,mCAAA;EACA,2BAAA;AAhCZ;AAoCI;EACI;IACI,UAAA;IACA,uCAAA;EAlCV;EAqCM;IACI,UAAA;IACA,iCAAA;EAnCV;AACF;AAsCI;EAEI;IAEI,sCAAA;EAtCV;EAyCM;IACI,6CAAA;EAvCV;AACF;AA0CI;EAEI;IAEI,mBAAA;EA1CV;EA6CM;IACI,sBAAA;EA3CV;AACF;AA8CI;EACI;IACI,UAAA;IACA,2BAAA;EA5CV;EA+CM;IACI,UAAA;IACA,wBAAA;EA7CV;AACF","sourcesContent":[".device-control-page {\n    min-height: 124vh;\n    position: relative;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 24px;\n    //   background: linear-gradient(135deg, #0f172a, #312e81, #0891b2);\n\n\n    .animated-bg {\n        position: absolute;\n        inset: 0;\n\n        span {\n            position: absolute;\n            width: 260px;\n            height: 260px;\n            border-radius: 50%;\n            filter: blur(6px);\n            opacity: 0.45;\n            animation: floatBubble 8s infinite ease-in-out;\n        }\n\n        span:nth-child(1) {\n            background: #22d3ee;\n            top: 10%;\n            left: 10%;\n        }\n\n        span:nth-child(2) {\n            background: #a855f7;\n            right: 12%;\n            top: 20%;\n            animation-delay: 2s;\n        }\n\n        span:nth-child(3) {\n            background: #14b8a6;\n            bottom: 8%;\n            left: 35%;\n            animation-delay: 4s;\n        }\n    }\n\n    .device-card {\n        width: 100%;\n        max-width: 460px;\n        position: relative;\n        z-index: 2;\n        padding: 34px;\n        border-radius: 28px;\n        background: rgba(255, 255, 255, 0.16);\n        backdrop-filter: blur(18px);\n        box-shadow: 0 30px 80px rgba(0, 0, 0, 0.35);\n        border: 1px solid rgba(255, 255, 255, 0.22);\n        animation: cardEnter 0.7s ease;\n        background-color: #0f172a;\n\n        h1 {\n            margin: 14px 0 6px;\n            text-align: center;\n            color: #ffffff;\n            font-size: 32px;\n            font-weight: 800;\n        }\n\n        .subtitle {\n            text-align: center;\n            color: rgba(255, 255, 255, 0.75);\n            margin-bottom: 26px;\n        }\n    }\n\n    .device-icon {\n        width: 84px;\n        height: 84px;\n        margin: 0 auto;\n        border-radius: 26px;\n        background: linear-gradient(135deg, #22d3ee, #8b5cf6);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        box-shadow: 0 16px 35px rgba(34, 211, 238, 0.35);\n        animation: pulseIcon 2s infinite;\n\n        span {\n            font-size: 42px;\n        }\n    }\n\n    .configured-box {\n        margin-bottom: 20px;\n        padding: 16px;\n        border-radius: 18px;\n        background: rgb(8 172 68 / 64%);\n        border: 1px solid rgb(34 197 94 / 92%);\n        color: #ffffff;\n\n        span {\n            display: block;\n            font-size: 13px;\n            opacity: 0.75;\n            margin-bottom: 4px;\n            color: #ffffff;\n        }\n\n        strong {\n            font-size: 20px;\n            letter-spacing: 1px;\n        }\n    }\n\n    .input-group {\n        margin-bottom: 18px;\n\n        label {\n            display: block;\n            margin-bottom: 8px;\n            color: #ffffff;\n            font-weight: 600;\n        }\n\n        input {\n            width: 100%;\n            height: 56px;\n            border-radius: 16px;\n            border: 2px solid rgba(255, 255, 255, 0.22);\n            background: rgba(255, 255, 255, 0.92);\n            color: #111827;\n            font-size: 18px;\n            font-weight: 700;\n            padding: 0 16px;\n            outline: none;\n            transition: 0.25s ease;\n\n            &:focus {\n                border-color: #22d3ee;\n                box-shadow: 0 0 0 5px rgba(34, 211, 238, 0.22);\n                transform: translateY(-2px);\n            }\n        }\n    }\n\n    .example-box {\n        margin-bottom: 18px;\n\n        p {\n            color: rgba(255, 255, 255, 0.8);\n            margin-bottom: 10px;\n            font-size: 14px;\n        }\n\n        div {\n            display: flex;\n            gap: 10px;\n            flex-wrap: wrap;\n        }\n\n        button {\n            border: none;\n            border-radius: 999px;\n            padding: 8px 14px;\n            color: #ffffff;\n            background: rgba(255, 255, 255, 0.18);\n            cursor: pointer;\n            font-weight: 700;\n            transition: 0.25s ease;\n\n            &:hover {\n                background: #22d3ee;\n                color: #0f172a;\n                transform: translateY(-3px);\n            }\n        }\n    }\n\n    .alert {\n        padding: 13px 15px !important;\n        border-radius: 14px;\n        margin-bottom: 16px;\n        font-weight: 600;\n        animation: slideDown 0.3s ease;\n\n        &.error {\n            background: rgb(239 68 68 / 57%);\n            color: #fecaca !important;\n            border: 1px solid rgb(239 68 68 / 78%);\n        }\n\n        &.success {\n            background: rgba(34, 197, 94, 0.18);\n            color: #bbf7d0 !important;\n            border: 1px solid rgba(34, 197, 94, 0.35);\n        }\n    }\n\n    .action-row {\n        display: flex;\n        gap: 12px;\n\n        button {\n            height: 52px;\n            border: none;\n            border-radius: 16px;\n            font-size: 16px;\n            font-weight: 800;\n            cursor: pointer;\n            transition: 0.25s ease;\n        }\n    }\n\n    .save-btn {\n        flex: 1;\n        background: linear-gradient(135deg, #22d3ee, #3b82f6);\n        color: #ffffff;\n\n        &:hover {\n            transform: translateY(-3px);\n            box-shadow: 0 15px 30px rgba(34, 211, 238, 0.35);\n        }\n    }\n\n    .logout-btn {\n        flex: 1;\n        background:rgba(239, 68, 68, 0.85);\n        color: #ffffff;\n\n        &:hover {\n            background: rgba(239, 68, 68, 0.85);\n            transform: translateY(-3px);\n        }\n    }\n\n    .clear-btn {\n        width: 110px;\n        background: rgba(255, 255, 255, 0.18);\n        color: #ffffff;\n\n        &:hover {\n            background: rgba(239, 68, 68, 0.85);\n            transform: translateY(-3px);\n        }\n    }\n\n    @keyframes cardEnter {\n        from {\n            opacity: 0;\n            transform: translateY(35px) scale(0.96);\n        }\n\n        to {\n            opacity: 1;\n            transform: translateY(0) scale(1);\n        }\n    }\n\n    @keyframes floatBubble {\n\n        0%,\n        100% {\n            transform: translateY(0) translateX(0);\n        }\n\n        50% {\n            transform: translateY(-40px) translateX(35px);\n        }\n    }\n\n    @keyframes pulseIcon {\n\n        0%,\n        100% {\n            transform: scale(1);\n        }\n\n        50% {\n            transform: scale(1.08);\n        }\n    }\n\n    @keyframes slideDown {\n        from {\n            opacity: 0;\n            transform: translateY(-8px);\n        }\n\n        to {\n            opacity: 1;\n            transform: translateY(0);\n        }\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
